// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'offer-table';

export const Component = () => (
  <path
    fill='none'
    stroke='currentColor'
    strokeLinecap='round'
    strokeLinejoin='round'
    d='M5.438 9.575v-8.25a.75.75 0 0 1 .75-.75h10.5a.75.75 0 0 1 .75.75v8.813a.75.75 0 0 1-.75.75H8.264M5.438 3.575h12m-6 0v7.313m3-7.313v7.313M.563 10.675v6.75m0-1.125h11.25a2.25 2.25 0 0 0-2.25-2.25H6.75A2.25 2.25 0 0 0 4.5 11.8H.562M4.5 14.05h2.25M5.438 7.231h12'
  />
);

export const viewBox = '0 0 18 18';
